import React, { useState } from "react";
import "../styles/contact.css";
import validationRules from "../validations/contactusvalidationrules.json";
import MultilineInput from "../components/inputs/MultilineInput";
import PhoneInput from "../components/inputs/PhoneInput";
import EmailInput from "../components/inputs/EmailInput";

const Contact = () => {
  const [formData, setFormData] = useState({
    orgname: "",
    name: "",
    designation: "",
    email: "",
    phone: "+091-",
    message: "",
  });
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBlur = (field) => {
    const rule = validationRules[field];
    const value = formData[field];
    let errorMessage = "";

    if (rule.required && !value) {
      errorMessage = rule.errorMessage;
    } else if (rule.minLength && value.length < rule.minLength) {
      errorMessage = rule.errorMessage;
    }

    setErrors((prev) => ({ ...prev, [field]: errorMessage }));
  };

  const clearForm = () => {
    setFormData({
      orgname: "",
      name: "",
      designation: "",
      email: "",
      phone: "+091-",
      message: "",
    });
    setErrors({});
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    for (const field in formData) {
      const rule = validationRules[field];
      const value = formData[field];

      if (rule.required && !value) {
        isValid = false;
        newErrors[field] = rule.errorMessage;
        continue;
      }

      if (!value) continue;

      switch (rule.format) {
        case "email":
          const emailPattern = new RegExp(rule.pattern);
          if (!emailPattern.test(value)) {
            isValid = false;
            newErrors[field] = rule.errorMessage;
            break;
          }
          const domain = value.split("@")[1]?.toLowerCase();
          if (rule.restrictedDomains.includes(domain)) {
            isValid = false;
            newErrors[field] = rule.errorMessage;
          }
          break;

        case "phone":
          const [countryCode, phoneNumber] = value.split("-");
          const cleanCode = countryCode?.replace(/\D/g, "") || "";
          const cleanPhone = phoneNumber?.replace(/\D/g, "") || "";

          if (cleanCode.length !== rule.countryCodeLength) {
            isValid = false;
            newErrors[
              field
            ] = `Country code must be ${rule.countryCodeLength} digits`;
          } else if (cleanPhone.length !== rule.numberLength) {
            isValid = false;
            newErrors[
              field
            ] = `Phone number must be ${rule.numberLength} digits`;
          }
          break;

        default:
          if (rule.minLength && value.length < rule.minLength) {
            isValid = false;
            newErrors[field] = rule.errorMessage;
          }
      }
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      const email = process.env.REACT_APP_CONTACT_EMAIL;
      const mailtoLink = `mailto:${email}?subject=Contact Form Submission&body=Organisation: ${formData.orgname}%0D%0AName: ${formData.name}%0D%0ADesignation: ${formData.designation}%0D%0AEmail: ${formData.email}%0D%0APhone: ${formData.phone}%0D%0AMessage: ${formData.message}`;
      window.location.href = mailtoLink;
      clearForm();
    }
  };

  return (
    <section id="contact" className="contact">
      <h2>Contact Us</h2>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            name="orgname"
            placeholder="Organisation"
            value={formData.orgname}
            onChange={handleInputChange}
            onBlur={() => handleBlur("orgname")}
          />
          {errors.orgname && <span className="error">{errors.orgname}</span>}
        </div>
        <div className="form-group">
          <input
            type="text"
            name="name"
            placeholder="Name"
            value={formData.name}
            onChange={handleInputChange}
            onBlur={() => handleBlur("name")}
          />
          {errors.name && <span className="error">{errors.name}</span>}
        </div>
        <div className="form-group">
          <input
            type="text"
            name="designation"
            placeholder="Designation"
            value={formData.designation}
            onChange={handleInputChange}
            onBlur={() => handleBlur("designation")}
          />
          {errors.designation && (
            <span className="error">{errors.designation}</span>
          )}
        </div>

        <div className="form-group">
          <EmailInput
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            error={errors.email}
            setError={(error) => setErrors({ ...errors, email: error })}
          />
        </div>
        <div className="form-group">
          <PhoneInput
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            error={errors.phone}
            setError={(error) => setErrors({ ...errors, phone: error })}
          />
        </div>

        <div className="form-group">
          <MultilineInput
            name="message"
            label="Message"
            value={formData.message}
            onChange={handleInputChange}
            error={errors.message}
            setError={(error) => setErrors({ ...errors, message: error })}
            minLength={10}
          />
        </div>

        <div className="button-container">
          <button type="submit">Send</button>
        </div>
      </form>
    </section>
  );
};

export default Contact;
